<div class="page-container" [testId]="'systemapp-list-page-container'">
  <div class="search-section" [testId]="'systemapp-list-search-section'">
    <div nz-row [nzGutter]="24" class="search-row" [testId]="'systemapp-list-search-row'">
      <div
        nz-col
        [nzXs]="24"
        [nzSm]="24"
        [nzMd]="8"
        [nzLg]="8"
        class="search-input-container"
        [testId]="'systemapp-list-search-input-container'"
      >
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'systemapp-list-search-input-group'">
          <input
            [testId]="'systemapp-list-search-input'"
            type="text"
            nz-input
            placeholder="{{ 'systemapp.search-placeholder' | i18n }}"
            [(ngModel)]="searchKeyword"
            (keyup.enter)="search()"
          />
          <ng-template #suffixIconSearch [testId]="'systemapp-list-search-icon-template'">
            <i
              nz-icon
              nzType="search"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'systemapp.search-tooltip' | i18n"
              (click)="search()"
              [testId]="'systemapp-list-search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <button
          [testId]="'systemapp-list-reset-button'"
          nz-button
          nzType="default"
          (click)="resetSearch()"
          class="reset-button"
          nz-tooltip
          [nzTooltipTitle]="'common.reset' | i18n"
        >
          <i nz-icon nzType="clear"></i>
        </button>
      </div>

      <div nz-col [nzXs]="24" [nzSm]="8" [nzMd]="6" [nzLg]="6" class="action-buttons" [testId]="'systemapp-list-action-buttons'">
        <button nz-button nzType="primary" class="add-button" (click)="addSystemApp()" [testId]="'systemapp-list-add-button'">
          <i nz-icon nzType="plus" [testId]="'systemapp-list-add-icon'"></i>
          {{ 'systemapp.add' | i18n }}
        </button>
      </div>
    </div>
  </div>

  <div class="table-section" [testId]="'systemapp-list-table-section'">
    <nz-table
      [nzData]="listOfData"
      [nzLoading]="loading"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      nzSize="small"
      [nzScroll]="{ x: '100%', y: 'calc(100vh - 200px)' }"
      [testId]="'systemapp-list-table'"
    >
      <thead [testId]="'systemapp-list-table-header'">
        <tr>
          <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column" [testId]="'systemapp-list-header-serial'">{{
            'common.serial-number' | i18n
          }}</th>
          <th [testId]="'systemapp-list-header-id'">{{ 'systemapp.id' | i18n }}</th>
          <th [testId]="'systemapp-list-header-name'">{{ 'systemapp.name' | i18n }}</th>
          <th [testId]="'systemapp-list-header-description'">{{ 'systemapp.description' | i18n }}</th>
          <th [testId]="'systemapp-list-header-create-time'">{{ 'systemapp.create.time' | i18n }}</th>
          <th [testId]="'systemapp-list-header-update-time'">{{ 'systemapp.update.time' | i18n }}</th>
          <th nzRight [testId]="'systemapp-list-header-actions'">{{ 'common.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody [testId]="'systemapp-list-table-body'">
        <tr *ngFor="let item of listOfData; let i = index" [testId]="'systemapp-list-table-row-' + i">
          <td nzLeft class="text-center row-number-column" [testId]="'systemapp-list-cell-serial-' + i">{{ i + 1 }}</td>
          <td [title]="item.id" class="cell-tooltip" [testId]="'systemapp-list-cell-id-' + i">{{ item.id }}</td>
          <td [title]="item.name" class="cell-tooltip" [testId]="'systemapp-list-cell-name-' + i">{{ item.name }}</td>
          <td [title]="item.description" class="cell-tooltip" [testId]="'systemapp-list-cell-description-' + i">{{ item.description }}</td>
          <td
            [title]="item.createTime | date: 'yyyy-MM-dd HH:mm:ss'"
            class="cell-tooltip"
            [testId]="'systemapp-list-cell-create-time-' + i"
            >{{ item.createTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td
          >
          <td
            [title]="item.updateTime | date: 'yyyy-MM-dd HH:mm:ss'"
            class="cell-tooltip"
            [testId]="'systemapp-list-cell-update-time-' + i"
            >{{ item.updateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td
          >
          <td nzRight [testId]="'systemapp-list-cell-actions-' + i">
            <a (click)="editSystemApp(item.id)" [testId]="'systemapp-list-edit-link-' + i">{{ 'common.edit' | i18n }}</a>
            <nz-divider nzType="vertical" [testId]="'systemapp-list-divider-' + i" />
            <a (click)="deleteSystemApp(item.id)" [testId]="'systemapp-list-delete-link-' + i">{{ 'common.delete' | i18n }}</a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <div class="pagination-section" *ngIf="total > 0" [testId]="'systemapp-list-pagination-section'">
    <div class="pagination-info" [testId]="'systemapp-list-pagination-info'">{{ 'common.total-records' | i18n: { total: total } }}</div>
    <div class="pagination-controls" [testId]="'systemapp-list-pagination-controls'">
      <nz-pagination
        nzSize="small"
        [nzShowQuickJumper]="true"
        [nzPageIndex]="pageIndex"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        (nzPageIndexChange)="onPageChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [testId]="'systemapp-list-pagination'"
      />
    </div>
  </div>
</div>
